// extracted by mini-css-extract-plugin
module.exports = {"time":"Timer_time__D-skg","button":"Timer_button__3zuvX"};